import { render } from "./security_demographics_competition.html?vue&type=template&id=0203cbda&external"
import script from "./security_demographics_competition.js?vue&type=script&lang=js&external"
export * from "./security_demographics_competition.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__